'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.create = undefined;

var _storageKeys = require('../storageKeys');

var _messages = require('../common/messages');

var create = exports.create = function create(_ref, isExternalHost, onError) {
  var email = _ref.email,
      hubId = _ref.hubId,
      hstc = _ref.hstc;

  var anonymousIdentifiers = void 0;
  var userIdentifier = void 0;

  if (email) {
    userIdentifier = 'EMAIL:::' + email + ':::' + _storageKeys.accountId;
  } else if (hstc) {
    anonymousIdentifiers = hstc.split('.');
    if (anonymousIdentifiers.length > 1) {
      var utk = anonymousIdentifiers[1];
      if (isExternalHost) {
        userIdentifier = 'TEMP_ID:::' + utk + ':::' + _storageKeys.accountId;
      } else {
        userIdentifier = 'VISITOR:::' + utk + ':::' + _storageKeys.accountId;
      }
    }
  }

  if (!userIdentifier) {
    onError((0, _messages.eventError)('Could not identify user. Please specify either an email or __hstc cookie identifer.'));
  }

  return {
    user: userIdentifier,
    team: hubId,
    raw: {
      email: email,
      hubId: hubId,
      hstc: hstc
    }
  };
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/usage-tracker-core/static-1.104/js/identifiers/index.js
// module id = 1243
// module chunks = 3